import styled from 'styled-components/macro';

import { OrderActionAdditionalInfoText } from '../../../common/fontElements';
import { formInputTextForFilledBack } from '../../../common/colorConstants';
import { FullColoredButton } from '../../../common/buttonsComponents';
import { PolicyDescription } from '../../../common/policyStyles';

export const IssueStoreCreditButton = styled(FullColoredButton)``;

export const PolicyDescriptionError = styled(PolicyDescription)`
  color: ${(props) => (props.isError ? '#ff4d44' : '#333')};
`;

export const CancelStep = styled.div`
  padding: 10px 0;
`;

export const StepTitle = styled(OrderActionAdditionalInfoText)`
  padding: 10px 0;
  font-size: 12px;
`;

export const Subtext = styled.span`
  opacity: 0.9;
  color: #7f7f7f;
`;

// Step 1

export const RowContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;

  flex: 1 1;
`;

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: #ff0000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RefundRowContent = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;

  flex: 1 1;
`;

// Step 2

export const RefundCommentTextarea = styled.textarea`
  flex: 2 1;

  min-height: 120px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.3;
  padding: 5px;

  color: ${formInputTextForFilledBack};
  border: 1px solid #4697c3;
  background-color: #f8fafc;
`;

export const FlexPlaceholder = styled.div`
  flex: 1 10;
`;

export const OrderSummaryBox = styled.div`
  flex: 1 1;
  flex-direction: column;
`;

export const OrderSummaryHeader = styled.div`
  font-size: 11px;
  font-family: Lato-Bold, sans-serif;

  color: #1c6774;

  padding: 8px;
`;

export const DollarInputField = styled.input`
  width: 30px;
  height: 30px;

  color: #22386f;
  font-size: 12px;
  text-align: center;
  border: 1px solid #c0c9d2;
  border-radius: 5px;
  padding: 0 2px 0 5px;
  margin-left: 5px;
  margin-right: 5px;

  &::placeholder {
    color: #c0bec0;
  }
  &:focus {
    border: 1px solid #c0c9d2;
    outline: none;
  }
`;

export const CentInputField = styled.input`
  width: 30px;
  height: 30px;

  color: #22386f;
  font-size: 12px;
  text-align: center;
  border: 1px solid #c0c9d2;
  border-radius: 5px;
  padding: 0 2px 0 5px;
  margin-left: 5px;
  margin-right: 5px;

  &::placeholder {
    color: #c0bec0;
  }
  &:focus {
    border: 1px solid #c0c9d2;
    outline: none;
  }
`;

export const OrderSummaryInfo = styled.div`
  font-size: 9px;

  color: #1c6774;
  background-color: #f8fafc;

  border-radius: 3px;
  padding: 8px;
`;

export const OrderSubtotalInfo = styled.div`
  font-size: 9px;
  font-family: Lato-Bold, sans-serif;
`;
